// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"985afe4e","453":"781ebc55"}[chunkId] + ".chunk.js";
};